import React from "react";
import {Card, PullToRefresh, WhiteSpace} from 'antd-mobile';
import MobileWrapper from '../../layouts/MobileWrapper';
import './style.css';
import { connect } from 'react-redux';
import {push} from 'react-router-redux';
import {store} from '../../store/store';
import applicationCenterService from '../../services/Employee/application-center-service';

const statusMap = ["未提交", "未回复", "已回复"];

class MobileMyMonthlyReport extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      dataCount:0,
      data: [],
      pageSize:0,
      cardListRefreshing: false,
      cardListHeight: document.documentElement.clientHeight
    }
  }

  componentWillMount() {
    this.getListData();
  }

  getListData(gets = {page: 1}) {
    applicationCenterService.myMonthlyReport(gets, res => {
      res.data.list_data.Data.forEach(data => data.status_name = statusMap[data.status]);
      this.setState({dataCount: res.data.list_data.Total})
      this.setState({data: this.state.data.concat(res.data.list_data.Data)})
      this.setState({pageSize: res.data.list_data.PageSize})
      this.setState({refreshing: false});
    }, err => {

    })

  }

  goToDetail = (params) => {
    var path = {
    pathname:'/mobile/mobile-my-monthly-report-detail',
    state:params,
  }
    store.dispatch(push(path))
  }

  render() {
    const self = this;

    var cards = this.state.data.map(function (report, index) {
      return (
        <div key={index}>
        <WhiteSpace size="lg"/>
        <Card full onClick={(e) => self.goToDetail(report)}>
      <Card.Header title={report.type_name}/>
      <Card.Body>
      <div>报告人: {report.real_name} </div>
      <div>提交时间: {report.created_time_str}</div>
      <div>状态: {report.status_name} </div>
      </Card.Body>
      </Card>
      </div>
      );

    });


    return <div>
      <PullToRefresh
      ref = {el => this.ptr = el}
      style = {{
        height: this.state.cardListHeight,
          overflow: 'auto',
      }}
      direction = 'up'
      refreshing = {this.state.cardListRefreshing}
      onRefresh = {() => {
        if(this.state.data.length < this.state.dataCount){
          this.setState({refreshing: true});
          this.getListData({page: Math.floor(this.state.data.length/this.state.pageSize) + 1});
        }
      }}
    >
      {cards}
    </PullToRefresh>

    </div>

  }

}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileMyMonthlyReport));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileMyMonthlyReport.js